import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hive from './Hive';

export default class HiveWrapper extends Component {
    render() {
        return(
            <Hive config={this.props.config} />
        );
    }
}

HiveWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
